<div class="card card-nb h-100 w-100">
  <div class="card-body p-4 w-100">
    <h2 class="mb-2">{{ "subscription_license_exceeded_headline" | i18next }}</h2>
    <div class="d-flex flex-column">
      @if (licenseStatus) {
        <div class="mb-3" [innerHTML]="'subscription_license_exceeded_description_enabled' | i18next "></div>
      }
      @if (!licenseStatus) {
        <div class="mb-3" [innerHTML]="'subscription_license_exceeded_description_disabled' | i18next "></div>
      }
      <div class="mb-3">
        <i class="fa fa-info-circle red mr-2"></i>
        <span class="subinformations">{{ "subscription_license_exceeded_info" | i18next }}</span>
      </div>
      <div class="d-flex mt-auto w-100 justify-content-end mt-3">
        <p-toggleswitch [(ngModel)]="licenseStatus" (onChange)="onToggle($event.checked)"></p-toggleswitch>
      </div>
    </div>
  </div>
</div>
